var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"circleButton":"wCEex"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .wCEex{border:solid #fff;border-radius:50%;display:flex;align-items:center;justify-content:center;width:100%;height:100%}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

